module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_3_2.c415cfc4.png";